import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateOwnDriverInfo } from '@/modules/driver/actions/async/updateOwnDriver';
import { TUpdateOwnDriverInfoForm } from '@/modules/driver/model/driver';
import { getMyDriver } from '@/modules/driver/store/selectors';
import { AppDispatch } from '@/root-store';
import { useForm } from '@/shared/view/Form';
import { IDocsListItem } from '@src-common/view/components/DocsList';

import { EditDriverInfo } from './view';

interface IProps<T extends IDocsListItem> {
  docs: T[];
  onUploadDoc: (event: React.SyntheticEvent, document: T) => void;
  onFinishSubmit: () => void;
}

export const EditDriverInfoUs = <T extends IDocsListItem>({
  docs,
  onUploadDoc,
  onFinishSubmit,
}: IProps<T>) => {
  const dispatch = useDispatch() as AppDispatch;

  const driver = useSelector(getMyDriver);

  const postForm = useCallback(
    async (formValues: TUpdateOwnDriverInfoForm) => {
      const { isSucceed, result = {} } = await dispatch(updateOwnDriverInfo(formValues)).unwrap();

      if (isSucceed && !result.validationErrors && !result.baseErrors) {
        onFinishSubmit();
      }

      return result;
    },
    [dispatch, onFinishSubmit],
  );

  const {
    handleSubmit,
    form: {
      control,
      formState: { isSubmitting },
    },
  } = useForm({
    onSubmit: postForm,
    defaultValues: {
      licenseNumber: driver.licenseNumber,
      homeAddress: driver.homeAddress,
    },
  });

  return (
    <EditDriverInfo
      control={control}
      isSubmitting={isSubmitting}
      onSubmit={handleSubmit}
      docs={docs}
      onUploadDoc={onUploadDoc}
    />
  );
};
